import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-black text-white py-16 sm:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          <div>
            <img
              src="/logo/balmart-logo-final.png"
              alt="Balmart · Spend Less"
              className="h-16 w-auto object-contain mb-6"
            />
            <p className="text-white/50 text-sm leading-relaxed max-w-xs">
              Des soins scientifiquement formul&eacute;s pour une peau claire. Chaque ingr&eacute;dient a un r&ocirc;le.
            </p>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.2em] font-bold mb-6 text-white/40">Navigation</p>
            <div className="flex flex-col gap-3">
              <Link to="/shop" data-testid="footer-shop-link" className="text-sm text-white/60 hover:text-white transition-colors">Boutique</Link>
              <Link to="/routine" data-testid="footer-routine-link" className="text-sm text-white/60 hover:text-white transition-colors">La Routine</Link>
              <Link to="/cart" data-testid="footer-cart-link" className="text-sm text-white/60 hover:text-white transition-colors">Panier</Link>
            </div>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.2em] font-bold mb-6 text-white/40">Contact</p>
            <div className="flex flex-col gap-3">
              <Link to="/contact" data-testid="footer-contact-link" className="text-sm text-white/60 hover:text-white transition-colors">Nous Contacter</Link>
              <a href="mailto:serviceclient@balmarts.com" data-testid="footer-email" className="text-sm text-white/60 hover:text-white transition-colors">serviceclient@balmarts.com</a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 text-center">
          <p className="text-white/30 text-xs tracking-widest uppercase">
            2026 BALMART All Rights Reserved
          </p>
        </div>
      </div>
    </footer>
  );
}
